export default {
  term_only:
    'By submitting this form, you are agreed with <1>Terms of Use</1>.',
  privacy_only:
    'By submitting this form, you are agreed with <1>Privacy Policy</1>.',
  term_privacy:
    'By submitting this form, you are agreed with <1>Terms of Use</1> and <3>Privacy Policy</3>.',
}
